(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-chmaps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BUTTON_SELECTORS = [
      '.ns-btn',
      '.button--primary',
      '.btn--primary',
      '.action_button:not([class*="upcart"])'
    ].join(', ');

    function findCartForms() {
      return Array.prototype.filter.call(
        document.querySelectorAll('form[action*="/cart/add"]'),
        function (f) { return f.offsetParent !== null; }
      );
    }

    function findAtcButtons() {
      return Array.prototype.filter.call(
        document.querySelectorAll(BUTTON_SELECTORS),
        function (btn) { return btn.offsetParent !== null; }
      );
    }

    function findInsertionAnchor(button) {
      var boundary = button.closest('form[action*="/cart/add"]') || document.body;
      var node = button;
      while (node.parentElement && node.parentElement !== boundary) {
        node = node.parentElement;
      }
      return node;
    }

    function isCorrectlyPlaced(root, anchor) {
      return root.isConnected && root.nextElementSibling === anchor;
    }

    function relocateBeforeButton(root) {
      var buttons = findAtcButtons();
      var button = buttons[0];
      if (!button) return;
      var anchor = findInsertionAnchor(button);
      if (anchor && anchor.parentNode && !isCorrectlyPlaced(root, anchor)) {
        anchor.parentNode.insertBefore(root, anchor);
      }
    }

    function getFieldLabel(root, field) {
      var input = root.querySelector('[data-ns-aura-field="' + field + '"]');
      var label = root.querySelector('label[for="' + input.id + '"]');
      return label ? label.textContent.trim() : field;
    }

    function ensureHiddenInput(form, root, field, value) {
      var name = 'properties[' + getFieldLabel(root, field) + ']';
      var hidden = form.querySelector('input[data-ns-aura-hidden="' + field + '"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.setAttribute('data-ns-aura-hidden', field);
        form.appendChild(hidden);
      }
      hidden.value = value;
    }

    // Écrit dans les attributs du panier (indépendant de la façon dont
    // MoonBundle ajoute le produit). Visible dans la commande, admin
    // Shopify, sous "Détails supplémentaires".
    function pushCartAttributes(root, inputs) {
      var attributes = {};
      inputs.forEach(function (input) {
        var label = getFieldLabel(root, input.getAttribute('data-ns-aura-field'));
        attributes[label] = input.value.trim();
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {
        // Silencieux : un échec réseau ponctuel ne doit pas bloquer la saisie.
      });
    }

    function initNsAuraForm(root) {
      var inputs = root.querySelectorAll('[data-ns-aura-field]');
      var errorEl = root.querySelector('[data-ns-aura-error]');
      var relocateTimer = null;
      var cartAttrTimer = null;
      var attempted = false;
      var showError = false;

      function isValid() {
        var valid = true;
        inputs.forEach(function (input) {
          var filled = input.value.trim().length > 0;
          input.classList.toggle('ns-aura-form__input--invalid', attempted && !filled);
          if (!filled) valid = false;
        });
        return valid;
      }

      function scheduleCartAttributesPush() {
        clearTimeout(cartAttrTimer);
        cartAttrTimer = setTimeout(function () {
          pushCartAttributes(root, inputs);
        }, 400);
      }

      function sync() {
        var forms = findCartForms();
        var buttons = findAtcButtons();
        var valid = isValid();

        forms.forEach(function (form) {
          inputs.forEach(function (input) {
            ensureHiddenInput(form, root, input.getAttribute('data-ns-aura-field'), input.value.trim());
          });
        });

        buttons.forEach(function (btn) {
          btn.setAttribute('aria-disabled', String(!valid));
        });

        if (errorEl) errorEl.hidden = !showError;

        return { forms: forms, buttons: buttons, valid: valid };
      }

      function relocateAndSync() {
        relocateBeforeButton(root);
        sync();
      }

      relocateAndSync();
      inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          showError = false;
          sync();
          scheduleCartAttributesPush();
        });
      });

      document.addEventListener('submit', function (e) {
        attempted = true;
        var state = sync();
        if (!state.valid && state.forms.indexOf(e.target) !== -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError = true;
          sync();
          inputs[0].focus();
        }
      }, true);

      document.addEventListener('click', function (e) {
        var buttons = findAtcButtons();
        var clickedAtc = buttons.some(function (btn) {
          return btn === e.target || btn.contains(e.target);
        });
        if (!clickedAtc) return;

        attempted = true;
        var state = sync();
        if (!state.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError = true;
          sync();
          inputs[0].focus();
        } else {
          // Dernière écriture synchrone juste avant le vrai clic d'ajout,
          // pour éviter toute course avec le debounce ci-dessus.
          pushCartAttributes(root, inputs);
        }
      }, true);

      var observer = new MutationObserver(function () {
        clearTimeout(relocateTimer);
        relocateTimer = setTimeout(relocateAndSync, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.querySelectorAll('[data-ns-aura-form]').forEach(initNsAuraForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-chemin-de-vie"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  /* ---------- moteur Chemin de Vie (validé 24/24) ---------- */
  var G = {}, BL = ["AJS","BKT","CLU","DMV","ENW","FOX","GPY","HQZ","IR"];
  BL.forEach(function (b, i) { b.split("").forEach(function (c) { G[c] = i + 1; }); });
  var VOY = "AEIOUY";
  var P = {1:"Quartz rose",2:"Jaspe rouge",3:"Calcédoine",4:"Jade",5:"Émeraude",6:"Grenat",7:"Citrine",8:"Obsidienne",9:"Aigue marine",10:"Rhodochrosite",11:"Cornaline",12:"Ambre",13:"Hématite",14:"Améthyste",15:"Malachite",16:"Opale",17:"Turquoise",18:"Pierre de lune",19:"Topaze",20:"Lapis Lazuli",21:"Tourmaline",22:"Cristal de roche",23:"Azurite",24:"Amazonite",25:"Œil de tigre",26:"Pyrite",27:"Fluorite",28:"Perle",29:"Sodalite",30:"Quartz fumé",31:"Soufre",32:"Mercure",33:"Sel"};
  var SUB = {5:"Aventurine",31:"Pierre de Lune",32:"Mokaïte",33:"Quartz Tourmaline"};
  var POS = ["Base","Sommet","Chemin de Vie","Appel","Personnalité","Expression","Touche","Vœux"];

  function norm(t) {
    return String(t).toUpperCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
      .split("").filter(function (c) { return G[c] !== undefined; }).join("");
  }
  function decoup(p) {
    return String(p).replace(/[‐‑–—]/g, "-")
      .replace(/\s*-\s*/g, "-").replace(/[;,]/g, " ").split(/\s+/).filter(Boolean);
  }
  function red(n) { while (n > 33) { n = String(n).split("").reduce(function (a, c) { return a + (+c); }, 0); } return n; }

  function calc(pr, pe, me, j, mo, an) {
    var M = decoup(pr).concat([pe, me]).map(norm).filter(function (x) { return x.length; });
    if (M.length < 2) return null;
    var p1 = 0, p2 = 0, p4 = 0, p5 = 0, p8 = 0;
    M.forEach(function (m) {
      p1 += G[m[0]]; p2 += G[m[m.length - 1]];
      for (var i = 0; i < m.length; i++) { if (VOY.indexOf(m[i]) >= 0) p4 += G[m[i]]; else p5 += G[m[i]]; }
      for (var k = 0; k < m.length; k++) { if (VOY.indexOf(m[k]) >= 0) { p8 += G[m[k]]; break; } }
    });
    var p3 = j + mo + an, p6 = p4 + p5, p7 = p1 + p2 + p4 + p5 + p6;
    return [p1, p2, p3, p4, p5, p6, p7, p8].map(function (b, i) {
      var r = red(b);
      return { pos: POS[i], n: r, pierre: SUB[r] || P[r] };
    });
  }

  /* ---------- date : champ libre, TOUT est accepté ----------
     Les clientes écrivent « 9 nov 45 », « 9 novembre 1945 », « 09.11.45 »...
     Le parseur essaie très large. S'il échoue, la commande passe QUAND MÊME
     et la date brute est transmise avec un drapeau pour calcul manuel.
     Une commande ne doit jamais être perdue sur un format de date.          */
  var MOIS = {
    jan:1, janv:1, janvier:1,
    fev:2, fevr:2, fevrier:2, feb:2,
    mar:3, mars:3,
    avr:4, avri:4, avril:4,
    mai:5,
    juin:6, jun:6,
    juil:7, juill:7, juillet:7, jul:7,
    aou:8, aout:8, aoust:8, ao:8,
    sep:9, sept:9, septembre:9,
    oct:10, octo:10, octobre:10,
    nov:11, nove:11, novembre:11,
    dec:12, dece:12, decembre:12
  };

  function anPlein(a) {
    if (a >= 1000) return a;
    return a <= 25 ? 2000 + a : 1900 + a;   /* 05 -> 2005 · 45 -> 1945 */
  }

  function parseDate(s) {
    var t = String(s).toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/\b(le|du|ne[e]?s?|en)\b/g, " ")
      .replace(/(\d)\s*(er|eme|e)\b/g, "$1")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
    if (!t) return null;

    var j = null, mo = null, an = null;
    var toks = t.split(" ").filter(Boolean);

    /* mois écrit en lettres, même abrégé */
    for (var i = 0; i < toks.length; i++) {
      if (/^[a-z]+$/.test(toks[i])) {
        var k = toks[i];
        if (MOIS[k]) { mo = MOIS[k]; toks[i] = ""; break; }
        for (var c = k.length; c >= 3; c--) {         /* "novemb" -> "nov" */
          if (MOIS[k.slice(0, c)]) { mo = MOIS[k.slice(0, c)]; toks[i] = ""; break; }
        }
        if (mo) break;
      }
    }

    /* on garde les CHAÎNES : "09" ne doit pas devenir 9 (zéro initial perdu) */
    var bruts = toks.filter(Boolean).filter(function (x) { return /^\d+$/.test(x); });
    var nums  = bruts.map(Number);

    if (mo !== null) {
      if (nums.length < 2) return null;
      j = nums[0]; an = nums[1];
    } else {
      if (bruts.length === 1 && (bruts[0].length === 8 || bruts[0].length === 6)) {
        var raw = bruts[0];                                    /* 09111945 / 091145 */
        j = +raw.slice(0, 2); mo = +raw.slice(2, 4); an = +raw.slice(4);
      } else if (nums.length >= 3) {
        j = nums[0]; mo = nums[1]; an = nums[2];
        if (j > 31 && an <= 31) { var tmp = j; j = an; an = tmp; }   /* 1945 11 9 */
      } else return null;
    }

    an = anPlein(an);
    if (!(j >= 1 && j <= 31 && mo >= 1 && mo <= 12 && an >= 1900 && an <= 2030)) return null;
    return { j: j, mo: mo, an: an, txt: ("0"+j).slice(-2) + "/" + ("0"+mo).slice(-2) + "/" + an };
  }

  /* ---------- intégration thème (repris de aura-chmaps) ---------- */
  var BUTTONS = ['.ns-btn', '.button--primary', '.btn--primary', '.action_button:not([class*="upcart"])'].join(', ');

  function cartForms() {
    return Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'),
      function (f) { return f.offsetParent !== null; });
  }
  function atcButtons() {
    return Array.prototype.filter.call(document.querySelectorAll(BUTTONS),
      function (b) { return b.offsetParent !== null; });
  }
  function anchorOf(button) {
    var boundary = button.closest('form[action*="/cart/add"]') || document.body, node = button;
    while (node.parentElement && node.parentElement !== boundary) node = node.parentElement;
    return node;
  }
  function relocate(root) {
    var b = atcButtons()[0]; if (!b) return;
    var a = anchorOf(b);
    if (a && a.parentNode && !(root.isConnected && root.nextElementSibling === a)) a.parentNode.insertBefore(root, a);
  }

  function init(root) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-cdv-field]'));
    var errEl = root.querySelector('[data-cdv-error]');
    var attempted = false, showError = false, msg = "", timer = null, push = null;

    function val(f) {
      var el = inputs.filter(function (i) { return i.getAttribute('data-cdv-field') === f; })[0];
      return el ? el.value.trim() : "";
    }
    function data() {
      var vide = inputs.filter(function (i) { return !i.value.trim(); });
      if (vide.length) return { ok: false, vides: vide, msg: "Merci de remplir tous les champs pour continuer." };

      var brute = val('date');
      var d = parseDate(brute);
      var r = d ? calc(val('prenoms'), val('pere'), val('mere'), d.j, d.mo, d.an) : null;

      /* Date illisible ou noms inexploitables : on laisse PASSER la commande
         et on signale le cas dans l'attribut, pour traitement à l'atelier. */
      var pierres = r
        ? r.map(function (s) { return s.pos + " : " + s.pierre + " (" + s.n + ")"; }).join(" · ")
        : "⚠️ À CALCULER MANUELLEMENT" + (d ? "" : " — date non reconnue");

      return {
        ok: true, r: r, attrs: {
          "Tous vos prénoms": val('prenoms'),
          "Nom de votre père": val('pere'),
          "Nom de jeune fille de votre mère": val('mere'),
          "Votre date de naissance": d ? d.txt : brute,
          "Taille de votre poignet": val('poignet'),
          "Pierres calculées": pierres
        }
      };
    }

    function pushCart(attrs) {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }
    function hidden(form, cle, v) {
      var i = form.querySelector('input[data-cdv-hidden="' + cle + '"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden';
                i.name = 'properties[' + cle + ']'; i.setAttribute('data-cdv-hidden', cle); form.appendChild(i); }
      i.value = v;
    }

    function sync() {
      var st = data();
      inputs.forEach(function (i) {
        var bad = attempted && st.vides && st.vides.indexOf(i) !== -1;
        i.classList.toggle('ns-cdv__input--invalid', !!bad);
      });
      if (st.ok) cartForms().forEach(function (f) {
        Object.keys(st.attrs).forEach(function (k) { hidden(f, k, st.attrs[k]); });
      });
      if (errEl) { errEl.hidden = !showError; if (showError) errEl.textContent = msg; }
      return st;
    }

    relocate(root); sync();

    inputs.forEach(function (i) {
      var ev = i.tagName === 'SELECT' ? 'change' : 'input';
      i.addEventListener(ev, function () {
        showError = false;
        var st = sync();
        if (st.ok) { clearTimeout(push); push = setTimeout(function () { pushCart(st.attrs); }, 400); }
      });
    });

    function guard(e) {
      attempted = true;
      var st = sync();
      if (!st.ok) {
        e.preventDefault(); e.stopImmediatePropagation();
        showError = true; msg = st.msg; sync();
        (st.vides[0] || inputs[0]).focus();
        return false;
      }
      pushCart(st.attrs);
      return true;
    }

    document.addEventListener('submit', function (e) {
      if (cartForms().indexOf(e.target) === -1) return;
      guard(e);
    }, true);

    document.addEventListener('click', function (e) {
      var hit = atcButtons().some(function (b) { return b === e.target || b.contains(e.target); });
      if (hit) guard(e);
    }, true);

    var obs = new MutationObserver(function () {
      clearTimeout(timer); timer = setTimeout(function () { relocate(root); sync(); }, 50);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-ns-cdv]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-logo-bar"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_logo_bar_section");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-top-promo-bar-mobile"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_top_promo_slid");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb-top-promo-bar"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skb_top_promo_slid");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skb_product_sticky_cart"] && !Shopify.designMode) return;
  try {
    
$(function() {
    var header = $(".skbps_cart_class");
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 750) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
  
});

  } catch(e) { console.error(e); }
})();
})();
